import { useState, useEffect } from 'react';
import { GOAL_STEPS } from '../../../types/enum';

const macronutrientOptions = [
  {
    id: 'balanced',
    name: 'Balanced',
    protein: 30,
    carbs: 40,
    fat: 30,
  },
  {
    id: 'weightLoss',
    name: 'Weight Loss',
    protein: 40,
    carbs: 30,
    fat: 30,
  },
  {
    id: 'leanBulk',
    name: 'Lean Bulk',
    protein: 35,
    carbs: 45,
    fat: 20,
  },
  {
    id: 'generalBulk',
    name: 'General Bulk',
    protein: 25,
    carbs: 55,
    fat: 20,
  },
];

const DailyPCF = ({ setGoals, setCurrentStep }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    setSelectedOption('balanced');
    setGoals((prev) => ({
      ...prev,
      macronutrientSplit: { protein: 30, carbs: 40, fat: 30 },
    }));
  }, []);

  const handleOptionSelect = (option) => {
    setSelectedOption(option.id);
    setGoals((prev) => ({
      ...prev,
      macronutrientSplit: {
        protein: option.protein,
        carbs: option.carbs,
        fat: option.fat,
      },
    }));
  };

  const handleNext = async () => {
    try {
      setCurrentStep(GOAL_STEPS.SUMMARY);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 className='font-bold mb-3 text-white text-2xl'>
        Select Your Macronutrient Split (Protein, Carbs, Fat)
      </h1>

      <div className='space-y-4'>
        {macronutrientOptions.map((option) => (
          <div
            key={option.id}
            className={`bg-white/10 rounded-xl p-6 shadow-sm cursor-pointer transition-colors duration-200 ${
              selectedOption === option.id ? 'ring-2 ring-yellow-500' : ''
            }`}
            onClick={() => handleOptionSelect(option)}
          >
            <h2 className='text-xl font-bold mb-2 text-white'>{option.name}</h2>
            <div className='space-y-2'>
              <div className='flex justify-between text-white/80'>
                <span>Protein {option.protein}%</span>
                <span>Carbs {option.carbs}%</span>
                <span>Fat {option.fat}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 mt-5 ${
          !selectedOption ? 'opacity-40 cursor-not-allowed' : ''
        }`}
        onClick={handleNext}
      >
        Next
      </button>
    </div>
  );
};

export default DailyPCF;
